import gql from 'graphql-tag';

import type { LongFormDraft } from 'src/data/longForm/types';
import { executeGqlMutation } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_LONG_FORM_BUILDER_DRAFT } from './schema';

const MUTATION = gql`
  mutation CreateFormatCompliantLongFormDraft($id: ID!) {
    createFormatCompliantLongFormDraft(id: $id) {
      ...LongFormBuilderDraft
    }
  }
  ${FRAGMENT_LONG_FORM_BUILDER_DRAFT}
`;

export const createFormatCompliantLongFormDraft = async (originalDraftId: ID) => {
  const variables = {
    id: originalDraftId,
  };

  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<LongFormDraft>(result.data);
};
